<template>
  <div id="app">
    <router-view/>
    <site-footer></site-footer>
  </div>
</template>

<script>
import SiteFooter from './components/SiteFooter'
export default {
  components: {
    SiteFooter
  }
}
</script>

<style src="./assets/tailwind.css">
  
</style>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  @apply bg-gray-100;
}
</style>
